angular.module('unica_campaign_attachment.campaign_attachment_services', []);